module.exports = __webpack_public_path__ + "static/img/ic_decoration.e80779a1.png";